import { useState } from "react";
import { dispatch } from "../../state/store";
import { pushCreatedTableRowsIds, setHardwareRefresh } from "../../state/ducks";

import { strCode } from "../../consts";
import { hardwareService, notificationService, t } from "../../services";
import { responseUtil } from "../../utils";

export const useUpdateHardwareLocation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const mutationCallback = async (hubLocation) => {
    setLoading(true);
    setError(false);

    try {
      const res = await hardwareService.updateHardwareLocation(hubLocation);

      if (responseUtil.isResponseSuccessful(res)) {
        dispatch(pushCreatedTableRowsIds([hubLocation.hubId]));

        notificationService.showSuccess({
          title: t(strCode.UPDATE_HARDWARE_LOCATION_SUCCESS),
          message: t(strCode.UPDATE_HARDWARE_LOCATION_SUCCESS_INFO, {
            hubId: hubLocation.hubId
          })
        });

        dispatch(setHardwareRefresh(true));
      }

      return res;
    } catch (err) {
      setError(true);

      notificationService.showError({
        title: t(strCode.UPDATE_HARDWARE_LOCATION_ERROR),
        message: err?.response?.data?.error ? err?.response?.data?.error : err?.toString()
      });
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading, error };
};
